import { configure } from "@borealis/image/client";
import { hydrate as borealisHydrate } from "@borealis/react/client";
import type { ReactNode } from "react";

const applicationName = "job-company-profile-frontend";
configure(applicationName);

export async function hydrate<T = unknown>(id: string, render: (props: T) => ReactNode) {
	// Wait for DOM to be ready before checking for element
	await new Promise<void>((resolve) => {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => resolve());
		} else {
			resolve();
		}
	});

	// Skip hydration if the island element doesn't exist on this page
	if (!document.getElementById(id)) {
		return;
	}

	await borealisHydrate({
		id,
		i18nLoadAndActivate: (locale) => import(`../../locales/${locale}.po`),
		render,
	});
}
